import React from 'react';
import { AppProvider } from '../context/AppContext';

const RootElement = ({ children }) => {
    return <AppProvider>{children}</AppProvider>;
};

export default RootElement;